import { render, staticRenderFns } from "./downloadClient.vue?vue&type=template&id=1bdcb8b1&scoped=true&"
import script from "./downloadClient.vue?vue&type=script&lang=js&"
export * from "./downloadClient.vue?vue&type=script&lang=js&"
import style0 from "./downloadClient.vue?vue&type=style&index=0&id=1bdcb8b1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bdcb8b1",
  null
  
)

export default component.exports